import { render, staticRenderFns } from "./status-menu-item.vue?vue&type=template&id=773f3c32"
import script from "./status-menu-item.vue?vue&type=script&lang=js"
export * from "./status-menu-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports